window.addEventListener('alpine:init', bootstrap);

export default () => ({
	open: false,
	setup: false,
	from_insights: false,
	init() {
		this.setup = true;
	},
	showModal() {
		this.open = true;
		this.from_insights = this.$event?.detail?.source === 'insights';
	},
	hideModal() {
		this.open = false;
	}
});

function bootstrap() {
	document.querySelectorAll('.js-opportunity-modal').forEach(
		$$ => bootstrapModal($$)
	);

	document.querySelectorAll('.js-opportunity-modal-trigger').forEach(
		$$ => bootstrapTrigger($$)
	);

	document.querySelectorAll('.js-opportunity-modal-close').forEach(
		$$ => bootstrapClose($$)
	);
}

function bootstrapModal($el) {
	$el.setAttribute('x-data', 'opportunityModal');
	$el.setAttribute('x-show', 'open');
	$el.setAttribute(':class', '{ "is-setup": setup }');
	$el.setAttribute('x-on:show-opportunity-modal.window', 'showModal');
	$el.setAttribute('x-on:hide-opportunity-modal.window', 'hideModal');

	const $row = $el.querySelector('.vc_row');
	if ( $row ) {
		$row.setAttribute('x-on:click.stop', '');
		$row.setAttribute('x-trap.noscroll.inert', 'open');
	}
}

function bootstrapTrigger($el) {
	$el.setAttribute('x-data', '');
	$el.setAttribute('x-on:click.prevent', `$dispatch("show-opportunity-modal")`);
}

function bootstrapClose($el) {
	$el.setAttribute('x-on:click.prevent', `$dispatch("hide-opportunity-modal")`);
}
